var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutScanSettingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1277_16298)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1277_16298)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1277_16298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 0H9.2C4.11898 0 0 4.11898 0 9.2V70C0 75.081 4.11898 79.2 9.2 79.2H70C75.081 79.2 79.2 75.081 79.2 70V9.2C79.2 4.11898 75.081 0 70 0Z",
    fill: "#F8FBFF",
    stroke: "#F0F2F5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.8834 64.558L70 43.7075L45.1169 29.2422L9 50.0927L33.8834 64.558Z",
    fill: "#0C76BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0346 30.1572L33.8154 49.9337V63.5418L68.0346 43.7651V30.1572Z",
    fill: "#0C76BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8032 36.6084V50.2162L13.244 51.6164L13.5021 51.4678L20.292 55.3921V55.7088L33.8155 63.541V49.9329L21.4621 38.8445L10.8032 36.6084Z",
    fill: "#1D94DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8032 35.7805L21.5954 38.7283L55.8273 18.9501L45.0395 16L10.8032 35.7805Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5952 38.7274L55.8271 18.9492L68.0446 29.3134L33.8154 49.0855L21.5952 38.7274Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8032 35.7803V36.638L21.5792 39.782L33.8155 49.9329V49.0862L21.5954 38.7281L10.8032 35.7803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0346 29.3184L33.8154 49.0864V49.9331L68.0346 30.157V29.3184Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3361 38.3017L11.5439 35.3541L11.8589 35.1719L22.647 38.1223L22.3361 38.3017Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4445 37.662L12.6523 34.7142L12.9673 34.5322L23.7551 37.4824L23.4445 37.662Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5519 37.0204L13.7598 34.0726L14.0747 33.8906L24.8629 36.8408L24.5519 37.0204Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6535 36.3847L14.8613 33.4369L15.1763 33.2549L25.9644 36.205L25.6535 36.3847Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7619 35.745L15.9697 32.7972L16.2847 32.6152L27.0728 35.5654L26.7619 35.745Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8674 35.1064L17.0752 32.1585L17.3902 31.9766L28.1783 34.9267L27.8674 35.1064Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9738 34.4677L18.1816 31.5199L18.4966 31.3379L29.2847 34.2883L28.9738 34.4677Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0795 33.828L19.2876 30.8802L19.6026 30.6982L30.3904 33.6487L30.0795 33.828Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1862 33.1884L20.394 30.2409L20.709 30.0586L31.4968 33.009L31.1862 33.1884Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2917 32.5494L21.4995 29.6019L21.8145 29.4199L32.6023 32.3701L32.2917 32.5494Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3971 31.911L22.605 28.9632L22.92 28.7812L33.7078 31.7314L33.3971 31.911Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5048 31.2714L23.7129 28.3236L24.0279 28.1416L34.8157 31.0917L34.5048 31.2714Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6105 30.6327L24.8184 27.6849L25.1336 27.5029L35.9214 30.4531L35.6105 30.6327Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7184 29.9941L25.9263 27.0462L26.2413 26.8643L37.0294 29.8144L36.7184 29.9941Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8224 29.3551L27.0303 26.4076L27.3453 26.2256L38.1331 29.1757L37.8224 29.3551Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9294 28.7167L28.1372 25.7689L28.4522 25.5869L39.2403 28.5371L38.9294 28.7167Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0353 28.078L29.2432 25.1302L29.5581 24.9482L40.3463 27.8984L40.0353 28.078Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1413 27.4384L30.3491 24.4906L30.6641 24.3086L41.4522 27.2587L41.1413 27.4384Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2458 26.7997L31.4536 23.8519L31.7686 23.6699L42.5567 26.6204L42.2458 26.7997Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3522 26.1601L32.5601 23.2125L32.875 23.0303L43.6631 25.9807L43.3522 26.1601Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4553 25.5201L33.6631 22.5726L33.9781 22.3906L44.7662 25.3408L44.4553 25.5201Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5637 24.8798L34.7715 21.932L35.0865 21.75L45.8743 24.7001L45.5637 24.8798Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6652 24.2431L35.873 21.2955L36.188 21.1133L46.9758 24.0637L46.6652 24.2431Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7731 23.6044L36.981 20.6566L37.2959 20.4746L48.0838 23.425L47.7731 23.6044Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8786 22.9638L38.0864 20.0162L38.4014 19.834L49.1892 22.7844L48.8786 22.9638Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9855 22.3271L39.1934 19.3792L39.5083 19.1973L50.2964 22.1474L49.9855 22.3271Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0905 21.6874L40.2983 18.7396L40.6133 18.5576L51.4011 21.5078L51.0905 21.6874Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1969 21.0478L41.4048 18.0999L41.7198 17.918L52.5079 20.8681L52.1969 21.0478Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3029 20.4091L42.5107 17.4613L42.826 17.2793L53.6138 20.2294L53.3029 20.4091Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4084 19.7704L43.6162 16.8229L43.9312 16.6406L54.7193 19.5911L54.4084 19.7704Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5163 19.1315L44.7241 16.1839L45.0391 16.002L55.8269 18.9521L55.5163 19.1315Z",
    fill: "#3B3344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3359 38.2998L34.5561 48.6579L34.8661 48.4794L22.6469 38.1201L22.3359 38.2998Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4424 37.6618L35.6625 48.0199L35.9726 47.8414L23.7533 37.4824L23.4424 37.6618Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5483 37.0221L36.7685 47.3802L37.0783 47.2017L24.8593 36.8428L24.5483 37.0221Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6548 36.3847L37.8749 46.7425L38.1847 46.564L25.9654 36.2051L25.6548 36.3847Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7612 35.7451L38.9814 46.1032L39.2914 45.9247L27.0722 35.5654L26.7612 35.7451Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8672 35.1064L40.0873 45.4645L40.3971 45.286L28.1781 34.9268L27.8672 35.1064Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9736 34.4675L41.1938 44.8255L41.5035 44.647L29.2843 34.2881L28.9736 34.4675Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0801 33.8278L42.2999 44.1859L42.61 44.0074L30.3907 33.6484L30.0801 33.8278Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.186 33.1894L43.4062 43.5472L43.7162 43.3687L31.497 33.0098L31.186 33.1894Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.292 32.5498L44.5121 42.9079L44.8219 42.7294L32.6026 32.3701L32.292 32.5498Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3989 31.9111L45.6188 42.2692L45.9288 42.0907L33.7096 31.7314L33.3989 31.9111Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5049 31.2721L46.725 41.6302L47.0351 41.4517L34.8158 31.0928L34.5049 31.2721Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6113 30.6344L47.8315 40.9925L48.1412 40.814L35.9222 30.4551L35.6113 30.6344Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7173 29.9941L48.9374 40.3522L49.2472 40.1734L37.0279 29.8145L36.7173 29.9941Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8237 29.3564L50.0436 39.7145L50.3536 39.536L38.1344 29.1768L37.8237 29.3564Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9302 28.7177L51.1503 39.0758L51.4601 38.8973L39.2411 28.5381L38.9302 28.7177Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0361 28.0788L52.2563 38.4369L52.566 38.2584L40.3468 27.8994L40.0361 28.0788Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1421 27.4391L53.3648 37.7972L53.6746 37.6187L41.4527 27.2598L41.1421 27.4391Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2485 26.7978L54.4733 37.16L54.7834 36.9818L42.5595 26.6182L42.2485 26.7978Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.355 26.1589L55.5792 36.5207L55.8889 36.3422L43.6659 25.9795L43.355 26.1589Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4517 25.5251L56.6718 35.8832L56.9816 35.7047L44.7623 25.3457L44.4517 25.5251Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5576 24.8857L57.7778 35.2435L58.0878 35.065L45.8685 24.7061L45.5576 24.8857Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6646 24.2461L58.8847 34.6039L59.1945 34.4254L46.9755 24.0664L46.6646 24.2461Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.771 23.6084L59.9911 33.9665L60.3009 33.788L48.0819 23.4287L47.771 23.6084Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.877 22.9684L61.0968 33.3265L61.4069 33.148L49.1876 22.7891L48.877 22.9684Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9829 22.3298L62.2031 32.6878L62.5128 32.5094L50.2938 22.1504L49.9829 22.3298Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0898 21.6911L63.31 32.0492L63.6198 31.8707L51.4008 21.5117L51.0898 21.6911Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1958 21.0527L64.4159 31.4105L64.7257 31.2323L52.5064 20.873L52.1958 21.0527Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3018 20.4131L65.5219 30.7711L65.832 30.5926L53.6127 20.2334L53.3018 20.4131Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4082 19.7754L66.6284 30.1335L66.9381 29.955L54.7191 19.5957L54.4082 19.7754Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5146 19.1354L67.7348 29.4935L68.0446 29.315L55.8253 18.9561L55.5146 19.1354Z",
    fill: "#2D2735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0436 42.9092L33.8057 62.6764V63.5422L68.0436 43.7747V42.9092Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.292 54.8691V55.7092L33.806 63.5414V62.6755L20.292 54.8691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.244 50.8037L10.8032 49.3945V50.2163L13.244 51.6165V50.8037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.5308 55.2432V57.1603L25.7252 58.4327V56.5118L23.5308 55.2432Z",
    fill: "#0C76BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3374 54.2686V56.1857L24.5318 57.458V55.5372L22.3374 54.2686Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5317 55.5375V57.4584L25.7256 56.7783V54.8652L24.5317 55.5375Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3374 54.2685L24.5318 55.5371L25.7257 54.8649L23.5127 53.585L22.3374 54.2685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2318 55.8975C23.2416 56.2829 23.4856 56.6903 23.7765 56.8071C24.0674 56.9241 24.2952 56.7065 24.2854 56.3211C24.2755 55.9357 24.0315 55.5283 23.7406 55.4116C23.4497 55.2945 23.2219 55.5121 23.2318 55.8975Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4143 55.9711C23.4207 56.2229 23.58 56.4892 23.7704 56.5657C23.9605 56.6422 24.1094 56.4999 24.1028 56.2481C24.0961 55.9963 23.9367 55.73 23.7466 55.6535C23.5566 55.577 23.4076 55.7193 23.4143 55.9711Z",
    fill: "#6D6477"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.0239 56.6914V58.6085L28.2183 59.8809V57.9597L26.0239 56.6914Z",
    fill: "#0C76BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8296 55.7158V57.6329L27.024 58.9053V56.9841L24.8296 55.7158Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0244 56.9845V58.9056L28.2186 58.2256V56.3125L27.0244 56.9845Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8296 55.7158L27.024 56.9841L28.2182 56.3121L26.0052 55.0322L24.8296 55.7158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7249 57.3448C25.7348 57.7302 25.9788 58.1376 26.2697 58.2546C26.5606 58.3717 26.7884 58.1541 26.7785 57.7687C26.7687 57.3833 26.5247 56.9759 26.2338 56.8588C25.9425 56.7417 25.7151 56.9594 25.7249 57.3448Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9074 57.4174C25.9138 57.6692 26.0732 57.9355 26.2636 58.012C26.4537 58.0885 26.6026 57.9462 26.5959 57.6944C26.5896 57.4426 26.4302 57.1763 26.2401 57.0998C26.0497 57.0233 25.9008 57.1656 25.9074 57.4174Z",
    fill: "#6D6477"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.5034 58.1572V60.0743L30.6978 61.3467V59.4258L28.5034 58.1572Z",
    fill: "#0C76BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3086 57.1807V59.0978L29.503 60.3702V58.4493L27.3086 57.1807Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5034 58.4496V60.3705L30.6976 59.6904V57.7773L29.5034 58.4496Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3086 57.1806L29.503 58.4492L30.6972 57.777L28.4842 56.4971L27.3086 57.1806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2039 58.8098C28.2138 59.1952 28.4578 59.6026 28.7487 59.7193C29.0396 59.8364 29.2674 59.6188 29.2575 59.2334C29.2477 58.848 29.0037 58.4406 28.7128 58.3235C28.4218 58.2068 28.1938 58.4244 28.2039 58.8098Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3864 58.8832C28.3928 59.135 28.5522 59.4013 28.7426 59.4778C28.9327 59.5543 29.0816 59.412 29.0749 59.1602C29.0686 58.9084 28.9092 58.6421 28.7191 58.5656C28.5287 58.4891 28.3798 58.6314 28.3864 58.8832Z",
    fill: "#6D6477"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.998 59.6064V61.5236L33.1922 62.7959V60.8748L30.998 59.6064Z",
    fill: "#0C76BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8032 58.6309V60.548L31.9976 61.8204V59.8992L29.8032 58.6309Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.998 59.8995V61.8207L33.1919 61.1406V59.2275L31.998 59.8995Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8032 58.6308L31.9976 59.8991L33.1915 59.2272L30.9788 57.9473L29.8032 58.6308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6986 60.2608C30.7084 60.6462 30.9524 61.0536 31.2433 61.1707C31.5343 61.2877 31.762 61.0701 31.7522 60.6847C31.7423 60.2993 31.4983 59.8919 31.2074 59.7748C30.9162 59.6578 30.6884 59.8754 30.6986 60.2608Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8811 60.3334C30.8877 60.5852 31.0471 60.8515 31.2372 60.928C31.4273 61.0045 31.5762 60.8622 31.5696 60.6104C31.5629 60.3586 31.4038 60.0923 31.2134 60.0158C31.0236 59.9393 30.8747 60.0816 30.8811 60.3334Z",
    fill: "#6D6477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1529 50.6223L24.7354 46.917V49.1668L31.1529 52.8718V50.6223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7612 48.9057L24.9209 47.2656V48.8463L27.7612 50.4876V48.9057Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7612 50.2948L25.2964 48.8848L24.9209 49.0476L27.7612 50.695V50.2948Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2964 47.483L24.9209 47.2656V49.0474L25.2964 48.8846V47.483Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9246 50.7292L28.084 49.0889V50.6696L30.9246 52.3108V50.7292Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9246 52.118L28.4595 50.708L28.084 50.8709L30.9246 52.5182V52.118Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4595 49.3062L28.084 49.0889V50.8707L28.4595 50.7078V49.3062Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4551 50.6223L42.8726 46.917V49.1668L36.4551 52.8718V50.6223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8467 48.9057L42.687 47.2656V48.8463L39.8467 50.4876V48.9057Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8467 50.2948L42.3115 48.8848L42.687 49.0476L39.8467 50.695V50.2948Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.311 47.483L42.6866 47.2656V49.0474L42.311 48.8846V47.483Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6831 50.7292L39.5234 49.0889V50.6696L36.6831 52.3108V50.7292Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6831 52.118L39.1479 50.708L39.5234 50.8709L36.6831 52.5182V52.118Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1479 49.3062L39.5235 49.0889V50.8707L39.1479 50.7078V49.3062Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8677 37.0898L66.2852 33.3848V35.6342L59.8677 39.3392V37.0898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2593 35.3728L66.0996 33.7324V35.3131L63.2593 36.9544V35.3728Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2593 36.7616L65.724 35.3516L66.0996 35.5144L63.2593 37.1618V36.7616Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7236 33.95L66.0992 33.7324V35.5142L65.7236 35.3514V33.95Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0957 37.1951L62.9363 35.5547V37.1354L60.0957 38.7766V37.1951Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0957 38.5829L62.5605 37.1729L62.9363 37.3357L60.0957 38.983V38.5829Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5605 35.772L62.9364 35.5547V37.3365L62.5605 37.1736V35.772Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1963 41.5627L58.6135 37.8574V40.1069L52.1963 43.8122V41.5627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5874 39.8455L58.428 38.2051V39.7861L55.5874 41.4273V39.8455Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5874 41.2333L58.0525 39.8232L58.428 39.9864L55.5874 41.6337V41.2333Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0522 38.4227L58.4278 38.2051V39.9872L58.0522 39.824V38.4227Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4243 41.6677L55.2646 40.0273V41.6083L52.4243 43.2496V41.6677Z",
    fill: "#504759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4243 43.0565L54.8891 41.6465L55.2646 41.8096L52.4243 43.4567V43.0565Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8892 40.245L55.2647 40.0273V41.8094L54.8892 41.6463V40.245Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4485 51.4362L20.2917 55.3935V47.502L13.4482 43.5498L13.4485 51.4362Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2437 43.4277V51.6178L13.5018 51.4691V43.577L13.2437 43.4277Z",
    fill: "#0C76BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 45.8818V46.1171L20.2913 50.0412V49.8044L13.5015 45.8818Z",
    fill: "#9AA89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 46.6523V46.8876L20.2913 50.8117V50.575L13.5015 46.6523Z",
    fill: "#9AA89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 47.4219V47.6572L20.2913 51.5812V51.3445L13.5015 47.4219Z",
    fill: "#9AA89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 44.3438V44.579L20.2913 48.5031V48.2661L13.5015 44.3438Z",
    fill: "#9AA89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 45.1133V45.3486L20.2913 49.2726V49.0359L13.5015 45.1133Z",
    fill: "#9AA89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 48.1914V48.427L20.2913 52.3507V52.114L13.5015 48.1914Z",
    fill: "#9AA89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 48.96V49.1953L20.2913 53.1193V52.8826L13.5015 48.96Z",
    fill: "#9AA89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 49.7305V49.9658L20.2913 53.8898V53.6528L13.5015 49.7305Z",
    fill: "#9AA89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 50.499V50.7343L20.2913 54.6584V54.4216L13.5015 50.499Z",
    fill: "#9AA89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5426 45.4204L16.5977 44.8747V44.3818L17.5426 44.9275V45.4204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.543 45.4198L17.8203 45.2702V44.7773L17.543 44.9269V45.4198Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5977 44.3815L17.5426 44.9272L17.8199 44.7777L16.8602 44.2314L16.5977 44.3815Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5879 51.5278L44.5328 50.9822V50.4893L43.5879 51.0349V51.5278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5879 51.5282L43.3105 51.3786V50.8857L43.5879 51.0353V51.5282Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5328 50.4899L43.5879 51.0356L43.3105 50.8861L44.2703 50.3398L44.5328 50.4899Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6948 46.853L52.6398 46.3074V45.8145L51.6948 46.3598V46.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6953 46.8534L51.418 46.7038V46.2109L51.6953 46.3602V46.8534Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6402 45.8142L51.6953 46.3595L51.418 46.2103L52.3777 45.6641L52.6402 45.8142Z",
    fill: "#D7E2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8486 42.1049L60.7936 41.5593V41.0664L59.8486 41.612V42.1049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8481 42.1043L59.5708 41.9548V41.4619L59.8481 41.6114V42.1043Z",
    fill: "#B1BCB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.793 41.0661L59.8481 41.6118L59.5708 41.4622L60.5305 40.916L60.793 41.0661Z",
    fill: "#D7E2DC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1277_16298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1277_16298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1277_16298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutScanSettingIcon);
export default __webpack_public_path__ + "static/media/Out-scan-setting-icon.19e8731123410a198a3db34eedc6f36c.svg";
export { ForwardRef as ReactComponent };